/**
 * @generated SignedSource<<fdf38ef33cbe37535beab0d250485a1d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
import { Semver } from "@/common/relayCustomScalar";
export type CreateWorkspaceVersionInput = {
  fromVersionId?: string | null | undefined;
  version: Semver;
};
export type WorkspacePublishButtonMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateWorkspaceVersionInput;
  workspaceId: string;
};
export type WorkspacePublishButtonMutation$data = {
  readonly createWorkspaceVersion: {
    readonly version: Semver;
    readonly workspace: {
      readonly slug: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionHistoryItemFragment">;
  };
};
export type WorkspacePublishButtonMutation = {
  response: WorkspacePublishButtonMutation$data;
  variables: WorkspacePublishButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspacePublishButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "WorkspaceVersion",
        "kind": "LinkedField",
        "name": "createWorkspaceVersion",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "WorkspaceVersionHistoryItemFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "WorkspacePublishButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "WorkspaceVersion",
        "kind": "LinkedField",
        "name": "createWorkspaceVersion",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": [
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedAt",
            "storageKey": null
          },
          {
            "alias": "viewerCanDelete",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "DELETE_WORKSPACE_VERSION"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"DELETE_WORKSPACE_VERSION\")"
          },
          {
            "alias": "viewerCanUpdate",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "UPDATE_WORKSPACE_VERSION"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE_VERSION\")"
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "filters": null,
        "handle": "prependNode",
        "key": "",
        "kind": "LinkedHandle",
        "name": "createWorkspaceVersion",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          },
          {
            "kind": "Literal",
            "name": "edgeTypeName",
            "value": "WorkspaceVersionEdge"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1719da9ca71c3f345ff90d82b297b118",
    "id": null,
    "metadata": {},
    "name": "WorkspacePublishButtonMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspacePublishButtonMutation(\n  $workspaceId: ID!\n  $input: CreateWorkspaceVersionInput!\n) {\n  createWorkspaceVersion(id: $workspaceId, input: $input) {\n    version\n    workspace {\n      slug\n      id\n    }\n    ...WorkspaceVersionHistoryItemFragment\n    id\n  }\n}\n\nfragment WorkspaceVersionDeleteButtonFragment on WorkspaceVersion {\n  id\n  version\n  workspace {\n    id\n    slug\n  }\n}\n\nfragment WorkspaceVersionHistoryItemFragment on WorkspaceVersion {\n  version\n  createdAt\n  publishedAt\n  workspace {\n    slug\n    id\n  }\n  viewerCanDelete: viewerCan(action: DELETE_WORKSPACE_VERSION)\n  viewerCanUpdate: viewerCan(action: UPDATE_WORKSPACE_VERSION)\n  ...WorkspaceVersionDeleteButtonFragment\n  ...WorkspaceVersionRenameButtonFragment\n}\n\nfragment WorkspaceVersionRenameButtonFragment on WorkspaceVersion {\n  id\n  version\n}\n"
  }
};
})();

(node as any).hash = "006e85b53db00d43666ee55ad659d1ee";

export default node;
